import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path || location.pathname.startsWith(path + '/');

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200 transition-all duration-300">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3">
          <div className="w-10 h-10 bg-teal rounded-lg flex items-center justify-center">
            <i className="ri-phone-line text-2xl text-white"></i>
          </div>
          <span className="font-bold text-2xl text-navy">PointCalls</span>
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          <Link 
            to="/" 
            className={`text-base font-medium transition-colors ${isActive('/') && location.pathname === '/' ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Home
          </Link>
          <Link 
            to="/industries" 
            className={`text-base font-medium transition-colors ${isActive('/industries') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Industries
          </Link>
          <Link 
            to="/features" 
            className={`text-base font-medium transition-colors ${isActive('/features') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Features
          </Link>
          <Link 
            to="/pricing" 
            className={`text-base font-medium transition-colors ${isActive('/pricing') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Pricing
          </Link>
          <Link 
            to="/blog" 
            className={`text-base font-medium transition-colors ${isActive('/blog') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Blog
          </Link>
          <Link 
            to="/partnerships" 
            className={`text-base font-medium transition-colors ${isActive('/partnerships') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Partnerships
          </Link>
          <Link 
            to="/contact" 
            className={`text-base font-medium transition-colors ${isActive('/contact') ? 'text-teal' : 'text-gray-700 hover:text-teal'}`}
          >
            Contact
          </Link>
        </div>

        <div className="hidden lg:flex items-center gap-4">
          <a 
            href="tel:+16787376473" 
            className="px-6 py-3 border-2 border-navy text-navy font-semibold rounded-lg hover:bg-navy hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Call Demo
          </a>
          <a 
            href="https://tidycal.com/mattv/15-minute-meeting"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 bg-teal text-white font-semibold rounded-lg hover:bg-teal/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get Started
          </a>
        </div>

        <button 
          className="lg:hidden p-2 cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          <div className="w-6 h-6 flex items-center justify-center">
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-navy`}></i>
          </div>
        </button>
      </nav>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-6 space-y-4">
            <Link 
              to="/" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/industries" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Industries
            </Link>
            <Link 
              to="/features" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Features
            </Link>
            <Link 
              to="/pricing" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link 
              to="/blog" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </Link>
            <Link 
              to="/partnerships" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Partnerships
            </Link>
            <Link 
              to="/contact" 
              className="block text-base font-medium text-gray-700 hover:text-teal py-2"
              onClick={() => setMobileMenuOpen(false)}
            >
              Contact
            </Link>
            <div className="pt-4 space-y-3">
              <a 
                href="tel:+16787376473" 
                className="block w-full px-6 py-3 border-2 border-navy text-navy font-semibold rounded-lg hover:bg-navy hover:text-white transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
              >
                Call Demo
              </a>
              <a 
                href="https://tidycal.com/mattv/15-minute-meeting"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full px-6 py-3 bg-teal text-white font-semibold rounded-lg hover:bg-teal/90 transition-all duration-200 text-center whitespace-nowrap cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                Get Started
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
